import {Option} from './option-info';

export class NodeSelection {
  selectedNode = -1;
  selectedChildNode = -1;
  selectedChild = -1;
  level = 1;
}

export class HierarchicNode extends Option  {
  children: HierarchicNode[] = [];
  level = 0;
  full_path: string;
  code: string;
  parent_id: string;
  parent_id_value: string;
  place_type_id_value: string;
  $$nodeType = '';
  $$open = true;
  $$name: string;
  $$description: string;
  $$disabled: boolean;
  $$hasParent: boolean;
  $$rows: number;
  $$parentNode: HierarchicNode;
  $$grandChildrenSet: boolean;
  /** True after a parent_id search has filled this node's children. */
  $$childrenLoaded: boolean;
  /** True when keyword search used Solr score sort (skip client A–Z re-sort). */
  $$relevanceSorted: boolean;
}

export class Level {
  level = 1;
}
